import React from 'react'
import DataTable from "react-data-table-component";
import { CSVLink } from "react-csv";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

const PaginatedTable = (props) => {

  const exportToCSV =  () => {
    let fileName = `Observation-${new Date().toISOString()}`;
    const fileType ="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const ws = XLSX.utils.json_to_sheet(props.data);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };
    return (
        <DataTable
        title={props.title}
        columns={props.columns}
        data={props.data.map((value) => {
          return value;
        })}
        pagination={true}
        subHeader={true}
        subHeaderComponent={props.data.length > 0 && <button onClick={() => exportToCSV()} className="btn btn-success"><i className="fa fa-cloud-download" aria-hidden="true"></i>&nbsp; Download</button>}
        paginationPerPage={100}
        paginationRowsPerPageOptions={[100,300,500]}
        fixedHeader={true} />
    )
}

export default PaginatedTable
